import { XIcon } from "@wags/ui/product-icons.tsx";
import { edgePanelRef } from "@wags/ui/browser-edges.tsx";
import { EDGE_COLORS } from "@wags/ui/edge-color.ts";
import type { Ref } from "react";

const chromeEdge = edgePanelRef(EDGE_COLORS.trueBlack);

export function PhotoViewerChrome({
    title,
    index,
    total,
    contentRef,
    onClose,
}: {
    title: string;
    index: number;
    total: number;
    contentRef: Ref<HTMLDivElement>;
    onClose: () => void;
}) {
    return (
        <div
            ref={chromeEdge}
            data-viewer-chrome
            className="fixed inset-x-0 top-0 z-2147483002 bg-true-black pt-[max(12px,env(safe-area-inset-top))] text-true-white md:pt-[env(safe-area-inset-top)]"
        >
            <div
                ref={contentRef}
                data-viewer-chrome-content
                className="flex h-13 items-center gap-3 pr-1 pl-4"
            >
                <h2 className="min-w-0 flex-1 truncate text-body font-medium">
                    {title}
                </h2>
                <p
                    aria-live="polite"
                    className="shrink-0 rounded-full bg-true-white/15 px-3 py-1 text-body-small font-medium tabular-nums"
                >
                    {index + 1} of {total}
                </p>
                <button
                    type="button"
                    aria-label="Close photos"
                    onClick={onClose}
                    className="flex size-11 shrink-0 items-center justify-center rounded-md text-true-white active:bg-true-white/15"
                >
                    <XIcon className="size-6" />
                </button>
            </div>
        </div>
    );
}
